import { render, staticRenderFns } from "./ScoreInfoView.vue?vue&type=template&id=521f89be&scoped=true"
import script from "./ScoreInfoView.vue?vue&type=script&lang=js"
export * from "./ScoreInfoView.vue?vue&type=script&lang=js"
import style0 from "./ScoreInfoView.vue?vue&type=style&index=0&id=521f89be&prod&lang=less&scoped=true"
import style1 from "./ScoreInfoView.vue?vue&type=style&index=1&id=521f89be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_c6nu2kfme4k2fztecbunkha7um/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f89be",
  null
  
)

export default component.exports